export default __webpack_public_path__ + "static/media/cloth2.8c8645ef.webp";